var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentMdl2FitPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.5L16.5 19.5L16.5 16.5L18 16.5L18 21L13.5 21L13.5 19.5ZM16.5 4.5L13.5 4.5L13.5 3L18 3L18 7.5L16.5 7.5L16.5 4.5ZM10.5 21L6 21L6 16.5L7.5 16.5L7.5 19.5L10.5 19.5L10.5 21ZM7.5 7.5L6 7.5L6 3L10.5 3L10.5 4.5L7.5 4.5L7.5 7.5ZM21 0L21 24L3 24L3 -7.86805e-07L21 0ZM4.5 22.5L19.5 22.5L19.5 1.5L4.5 1.5L4.5 22.5Z",
    fill: "#FF803B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMdl2FitPage);
export default __webpack_public_path__ + "static/media/fluent-mdl2_fit-page.7b5ba2bd886527a6e615749662ae82cc.svg";
export { ForwardRef as ReactComponent };